import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import ServiceDetail from './pages/ServiceDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import DashboardOverview from './pages/admin/DashboardOverview';
import ServicesManager from './pages/admin/ServicesManager';
import ProjectsManager from './pages/admin/ProjectsManager';
import StatsManager from './pages/admin/StatsManager';
import SiteSettingsManager from './pages/admin/SiteSettingsManager';
import SocialMediaManager from './pages/admin/SocialMediaManager';
import MediaLibrary from './pages/admin/MediaLibrary';
import HeroManager from './pages/admin/HeroManager';
import SEOManager from './pages/admin/SEOManager';
import ServiceDetailManager from './pages/admin/ServiceDetailManager';
import ServicesPageManager from './pages/admin/ServicesPageManager';
import AboutManager from './pages/admin/AboutManager';
import ContactSubmissions from './pages/admin/ContactSubmissions';
import InventoryLeadsManager from './pages/admin/InventoryLeadsManager';
import BlogManager from './pages/admin/BlogManager';
import WhatsAppButton from './components/WhatsAppButton';
import { Toaster } from './components/ui/sonner';
import { Navigate } from 'react-router-dom';

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <div className="App">
          <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<><Navbar /><Home /><Footer /></>} />
            <Route path="/services/:serviceId" element={<><Navbar /><ServiceDetail /><Footer /></>} />
            <Route path="/about" element={<><Navbar /><About /><Footer /></>} />
            <Route path="/contact" element={<><Navbar /><Contact /><Footer /></>} />
            <Route path="/privacy" element={<><Navbar /><PrivacyPolicy /><Footer /></>} />
            <Route path="/terms" element={<><Navbar /><TermsOfService /><Footer /></>} />
            <Route path="/blog" element={<><Navbar /><Blog /><Footer /></>} />
            <Route path="/blog/:slug" element={<><Navbar /><BlogDetail /><Footer /></>} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route 
              path="/admin/dashboard" 
              element={
                <ProtectedRoute>
                  <AdminDashboard><DashboardOverview /></AdminDashboard>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/services" 
              element={
                <ProtectedRoute>
                  <AdminDashboard><ServicesManager /></AdminDashboard>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/service-details" 
              element={
                <ProtectedRoute>
                  <AdminDashboard><ServiceDetailManager /></AdminDashboard>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/services-page" 
              element={
                <ProtectedRoute>
                  <AdminDashboard><ServicesPageManager /></AdminDashboard>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/about" 
              element={
                <ProtectedRoute>
                  <AdminDashboard><AboutManager /></AdminDashboard>
                </ProtectedRoute>
              } 
            />

            <Route 
              path="/admin/contact-submissions" 
              element={
                <ProtectedRoute>
                  <AdminDashboard><ContactSubmissions /></AdminDashboard>
                </ProtectedRoute>
              } 
            />

            <Route 
              path="/admin/inventory-leads" 
              element={
                <ProtectedRoute>
                  <AdminDashboard><InventoryLeadsManager /></AdminDashboard>
                </ProtectedRoute>
              } 
            />

            <Route 
              path="/admin/blogs" 
              element={
                <ProtectedRoute>
                  <AdminDashboard><BlogManager /></AdminDashboard>
                </ProtectedRoute>
              } 
            />

            <Route 
              path="/admin/projects" 
              element={
                <ProtectedRoute>
                  <AdminDashboard><ProjectsManager /></AdminDashboard>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/stats" 
              element={
                <ProtectedRoute>
                  <AdminDashboard><StatsManager /></AdminDashboard>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/hero" 
              element={
                <ProtectedRoute>
                  <AdminDashboard><HeroManager /></AdminDashboard>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/settings" 
              element={
                <ProtectedRoute>
                  <AdminDashboard><SiteSettingsManager /></AdminDashboard>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/seo" 
              element={
                <ProtectedRoute>
                  <AdminDashboard><SEOManager /></AdminDashboard>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/social" 
              element={
                <ProtectedRoute>
                  <AdminDashboard><SocialMediaManager /></AdminDashboard>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/media" 
              element={
                <ProtectedRoute>
                  <AdminDashboard><MediaLibrary /></AdminDashboard>
                </ProtectedRoute>
              } 
            />
          </Routes>
          <Toaster />
          <WhatsAppButton />
        </BrowserRouter>
      </div>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;